// Confirmed per-record warehouse operations; stock is owned by the server.
const WarehouseService = {
    REQUESTS_KEY:'ecpv_warehouse_requests',
    ORDERS_KEY:'ecpv_purchase_orders',
    init() {},
    getAllRequests() { return FileStorage.read(this.REQUESTS_KEY) || []; },
    getStudentRequests(studentId) { return this.getAllRequests().filter(r=>r.studentId===studentId); },
    getAllOrders() { return FileStorage.read(this.ORDERS_KEY) || []; },
    async createRequest(input) {
        const data={projectId:input.projectId,items:input.items,dates:input.dates,comments:input.comments || ''};
        const result=await WarehouseAPI.command('requests','POST',{...data,id:WarehouseAPI.draftId('request',data)},r=>WarehouseAPI.cache('warehouseRequests',[r.request]));
        return result?.request || null;
    },
    async updateRequestStatus(id,status,comments='') {
        const row=this.getAllRequests().find(r=>r.id===id);if(!row)return false;
        return !!await WarehouseAPI.command('requests/'+encodeURIComponent(id)+'/status','PUT',
            {status,comments,expectedUpdatedAt:row.updatedAt},r=>{
                WarehouseAPI.cache('warehouseRequests',[r.request]);
                WarehouseAPI.cache('inventory',r.inventory || []);
            });
    },
    async deleteRequest(id) {
        const row=this.getAllRequests().find(r=>r.id===id);if(!row)return false;
        return !!await WarehouseAPI.command('requests/'+encodeURIComponent(id),'DELETE',{expectedUpdatedAt:row.updatedAt},
            ()=>WarehouseAPI.cache('warehouseRequests',this.getAllRequests().filter(r=>r.id!==id),true));
    },
    async createOrder(input) {
        const data={items:input.items,reason:input.reason || ''};
        const result=await WarehouseAPI.command('orders','POST',{...data,id:WarehouseAPI.draftId('order',data)},r=>WarehouseAPI.cache('purchaseOrders',[r.order]));
        return result?.order || null;
    },
    calculateTotal(items) { return items.reduce((sum,i)=>sum+Math.round(Number(i.price)*100)*Number(i.qty),0)/100; },
    async changeOrder(id,status,reason='') {
        const row=this.getAllOrders().find(r=>r.id===id);if(!row)return false;
        return !!await WarehouseAPI.command('orders/'+encodeURIComponent(id)+'/status','PUT',
            {status,reason,expectedUpdatedAt:row.updatedAt},r=>{
                WarehouseAPI.cache('purchaseOrders',[r.order]);
                WarehouseAPI.cache('inventory',r.inventory || []);
            });
    },
    approveOrder(id) { return this.changeOrder(id,'approved'); },
    rejectOrder(id,reason) { return this.changeOrder(id,'rejected',reason); },
    receiveOrder(id) { return this.changeOrder(id,'received'); }
};
window.WarehouseService=WarehouseService;
